var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectiveActionRequestSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 40,
    viewBox: "0 0 51 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5167 28.2497C23.2 28.2497 22.8833 28.133 22.6333 27.883L20.1333 25.383C19.65 24.8997 19.65 24.0997 20.1333 23.6164C20.6167 23.133 21.4167 23.133 21.9 23.6164L23.5167 25.233L29.3 19.4497C29.7833 18.9664 30.5833 18.9664 31.0667 19.4497C31.55 19.933 31.55 20.733 31.0667 21.2164L24.4 27.883C24.1667 28.133 23.8333 28.2497 23.5167 28.2497Z",
    fill: "#5D9FE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3478 5.54043C32.8927 2.08301 30.2898 2.08301 28.8333 2.08301H22.1667C20.7082 2.08301 18.1002 2.08301 17.6503 5.55462C11.6959 6.20038 9.25 9.49889 9.25 16.6664V26.6664C9.25 33.6164 11.1333 37.9164 20.5 37.9164H30.5C39.8667 37.9164 41.75 33.6164 41.75 26.6498V16.6498C41.75 9.4972 39.3036 6.19965 33.3478 5.54043ZM28.8333 11.2497H22.1667C20.7475 11.2497 18.2401 11.2497 17.6914 8.05144C13.7557 8.51307 11.75 10.259 11.75 16.6664V26.6664C11.75 32.8331 12.9667 35.4164 20.5 35.4164H30.5C38.0333 35.4164 39.25 32.8331 39.25 26.6664V16.6664C39.25 10.279 37.2568 8.52398 33.3453 8.05578C33.1309 9.57029 32.2721 11.2497 28.8333 11.2497ZM30.9167 6.75424C30.916 8.3318 30.8792 8.74967 28.8333 8.74967H22.1667C20.5434 8.74967 20.0977 8.74967 20.0837 6.76598C20.0853 6.72777 20.0852 6.68907 20.0833 6.64995C20.0856 4.58301 20.521 4.58301 22.1667 4.58301H28.8333C30.4747 4.58301 30.9121 4.58301 30.9166 6.63383C30.9147 6.67429 30.9147 6.71446 30.9167 6.75424Z",
    fill: "#5D9FE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectiveActionRequestSearchIcon);
export default __webpack_public_path__ + "static/media/CorrectiveActionRequestSearchIcon.c721410a73a6ccc59e53cd455d80528c.svg";
export { ForwardRef as ReactComponent };